// src/utils/sentryUtils.js
import * as Sentry from "@sentry/react";

export const logInfo = (message, data = {}) => {
  Sentry.addBreadcrumb({
    category: "info",
    message,
    data,
    level: "info",
  });
};

export const captureError = (error, context = {}) => {
  Sentry.withScope((scope) => {
    scope.setExtras(context);
    Sentry.captureException(error);
  });
};

export const captureEvent = (eventName, data = {}) => {
  Sentry.captureMessage(eventName, {
    level: "info",
    extra: data,
  });
};

export const setUser = (user) => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name,
  });
};

export const clearUser = () => {
  Sentry.setUser(null);
};

/**
 * Wraps an async operation in a Sentry span for performance tracing.
 * Usage: const result = await withSpan("widget.load", () => fetchWidgetData(key));
 */
export const withSpan = async (name, operation, attributes = {}) => {
  return Sentry.startSpan({ name, attributes }, () => operation());
};

/**
 * Records a user action breadcrumb (button clicks, form submits, navigation steps).
 */
export const logUserAction = (action, data = {}) => {
  Sentry.addBreadcrumb({
    category: "user.action",
    message: action,
    data,
    level: "info",
  });
};

/**
 * Records a navigation breadcrumb for widget step changes.
 */
export const logNavigation = (from, to, data = {}) => {
  Sentry.addBreadcrumb({
    category: "navigation",
    message: `${from} → ${to}`,
    data,
    level: "info",
  });
};